'use client';

export { default } from './SwipeableDrawer';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SwipeableDrawer/index.js
// module id = 887
// module chunks = 22